import { Component, OnInit } from '@angular/core';
import { HelperService } from 'src/app/services/Helper/helper.service';
import { LookupService } from 'src/app/services/Lookup/lookup.service';
import { CodeSetupService } from 'src/app/services/code-setup.service';
import { ProviderParameters } from 'src/app/models/ui/ProviderParameters';
import { CodeSetsParameters } from 'src/app/models/ui/CodeSetsParameters';
import { CodeSetDto } from 'src/app/models/ui/CodeSetDto';
import { FormControl } from '@angular/forms';
import CustomStore from 'devextreme/data/custom_store';
import { map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-code-setup',
  templateUrl: './code-setup.component.html',
  styleUrls: ['./code-setup.component.css']
})
export class CodeSetupComponent implements OnInit {
  gridBoxServiceCodeValue: number[] = [];
  gridBoxDiagnosesValue: number[] = [];

  oldServiceCode: any[] = [];

  oldDiagnoses: any[] = [];

  deletableServiceCode: any[] = [];
  deletableDiagnoses: any[] = [];

  public codeSetsParameters: CodeSetsParameters;
  public deletableCodeSetsParameters: CodeSetsParameters;


  isAuthorized: string;

  provider: ProviderParameters;
  providerId: string;

  procedureCodeset: any;
  diagnosisCodeset: any;

  excludedProcedureCodeset: any[];
  excludedDiagnosisCodeset: any[];

  isloading:boolean=false;

  constructor(private helperService: HelperService, private lookupService: LookupService, private codesetupService: CodeSetupService , private toastr: ToastrService) {
    this.provider = new ProviderParameters();
    this.codeSetsParameters = new CodeSetsParameters();
    this.deletableCodeSetsParameters = new CodeSetsParameters();
  }

  ngOnInit() {
    this.isloading = true;
    this.isAuthorized = localStorage.getItem("isAuthorized");

    if (this.isAuthorized === "true") {
      this.helperService.setTitle("Provider - Code Setup");

      this.lookupService.getProvider().subscribe(data => this.provider = data);

      this.lookupService.getCodeSets(0).subscribe(
        (data) => { // Next
          this.procedureCodeset = this.makeAsyncDataSource(
            this.lookupService.getCodeSets(0)
              .pipe(
                map(data => data.CodeSets)
              ).toPromise());
          this.gridBoxServiceCodeValue = data.ExcludedcodeSets.map(cs => cs.Id);
          this.excludedProcedureCodeset = data.ExcludedcodeSets.map(cs => cs.Id);
          this.oldServiceCode = data.ExcludedcodeSets;
          this.deletableServiceCode = data.ExcludedcodeSets;
          this.isloading = false;
        },
        (error) => { 
          console.error('Error fetching procedure code data:', error);
          this.isloading = false; 
        }
      );
      

      this.lookupService.getCodeSets(1).subscribe(
        (data) => { 
          this.diagnosisCodeset = this.makeAsyncDataSource(
            this.lookupService.getCodeSets(1)
              .pipe(
                map(data => data.CodeSets)
              ).toPromise());
          this.gridBoxDiagnosesValue = data.ExcludedcodeSets.map(cs => cs.Id);
          this.excludedDiagnosisCodeset = data.ExcludedcodeSets.map(cs => cs.Id);
          this.oldDiagnoses = data.ExcludedcodeSets;
          this.deletableDiagnoses = data.ExcludedcodeSets;
          this.isloading = false;
        },
        (error) => { 
          console.error('Error fetching data:', error);
          this.isloading = false; 
        }
      );
      
    }
    else
      location.assign("#/login-form");
     
  }

  makeAsyncDataSource(a: any) {
    return new CustomStore({
      loadMode: 'raw',
      key: 'Id',
      load() {
        return a;
      },
    });
  }

  submitChanges() {
    const currentProviderId = localStorage.getItem("currentProvider");

    const newSelectedServiceCodes = this.gridBoxServiceCodeValue.filter(code => !this.oldServiceCode.some(oldCode => oldCode.Id === code));
    const newSelectedDiagnosisCodes = this.gridBoxDiagnosesValue.filter(code => !this.oldDiagnoses.some(oldCode => oldCode.Id === code));
    if(newSelectedServiceCodes.length > 0 || newSelectedDiagnosisCodes.length > 0)
    {
      this.codeSetsParameters.ProviderId = currentProviderId;
      this.codeSetsParameters.ServiceCodesIds = newSelectedServiceCodes;
      this.codeSetsParameters.DiagnosesIds = newSelectedDiagnosisCodes;
      this.codesetupService.submitCodesets(this.codeSetsParameters).subscribe(data => this.afterUpdate(data));
    }

    const deleteableServiceCode = this.excludedProcedureCodeset.filter(item => !this.gridBoxServiceCodeValue.includes(item));
    const deleteableDiagnoses = this.excludedDiagnosisCodeset.filter(item => !this.gridBoxDiagnosesValue.includes(item));
    if(deleteableServiceCode.length > 0 || deleteableDiagnoses.length > 0)
    {
      this.deletableCodeSetsParameters.ProviderId = currentProviderId;
      this.deletableCodeSetsParameters.ServiceCodesIds = deleteableServiceCode;
      this.deletableCodeSetsParameters.DiagnosesIds = deleteableDiagnoses;
      this.codesetupService.deleteableCodesets(this.deletableCodeSetsParameters).subscribe(data => this.afterUpdate(data));
    }
  }

  afterUpdate(data) {
    alert(data);
    setTimeout(() => {
      location.reload();
    }, 2000);
  }
}